import { Box } from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { UserData } from '@codefluegel/wowis-rest-typescript-client';
import useMedia from '../../hooks/useMedia';
import CardContainer from '../../components/cards/CardContainer';
import ContactListForm from '../../components/forms/ContactListForm';

interface Props {
  user: UserData | undefined;
}

const PhoneData: FC<Props> = observer(props => {
  const { user } = props;
  const isMobile = useMedia('md');

  const title = 'Kontaktdaten';

  return (
    <Box>
      <CardContainer
        title={title}
        customStyle={{
          sx: {
            margin: 0,
            marginBottom: 3,
          },
        }}
        iconOn
        iconName={title}
      >
        <Box
          sx={{
            width: 1,
            minHeight: isMobile ? 1 : '160px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {user?.customerId && <ContactListForm topUserId={user?.customerId} />}
        </Box>
      </CardContainer>
    </Box>
  );
});

export default PhoneData;
